module.exports = __webpack_public_path__ + "img/home-07-cosmo-03-coc-05.5291aeed.jpg";